<div class="text-center mt-10">
  <h3 class="font-weight-bold text-primary">Forgotten/Set Password ?</h3>
  <p class="text-muted">Enter your email to reset your password</p>
</div>

<form
  class="form p-10"
  #forgotpasswordform="ngForm"
  id="kt_login_forgot_form"
  [mustMatch]="['password', 'confirm_password']"
  (ngSubmit)="forgotpasswordform.form.valid && onSubmit()"
  novalidate
>
  <div *ngIf="current_page == 'forgot-password'" class="form-group py-3">
    <mat-form-field class="example-full-width">
      <input
        matInput
        type="email"
        required
        [(ngModel)]="forgotPasswordValue.email"
        placeholder="Email"
        name="email"
      />
    </mat-form-field>
  </div>

  <div
    *ngIf="current_page == 'verify-forgot-password-otp'"
    class="form-group py-3"
  >
    {{ forgotPasswordValue.email }}
  </div>

  <div
    *ngIf="current_page == 'verify-forgot-password-otp'"
    class="form-group py-3"
  >
    <mat-form-field class="example-full-width">
      <input
        matInput
        type="text"
        autocomplete="off"
        required
        [(ngModel)]="forgotPasswordValue.otp"
        placeholder="OTP"
        name="otp"
      />
    </mat-form-field>
  </div>

  <div
    *ngIf="current_page == 'verify-forgot-password-otp'"
    class="form-group py-3"
  >
    <mat-form-field class="example-full-width">
      <input
        matInput
        type="text"
        autocomplete="off"
        required
        [(ngModel)]="forgotPasswordValue.username"
        placeholder="Username"
        name="username"
      />
    </mat-form-field>
  </div>

  <div
    *ngIf="current_page == 'verify-forgot-password-otp'"
    class="form-group py-3"
  >
    <mat-form-field class="example-full-width">
      <input
        autocomplete="off"
        required
        matInput
        [type]="pwdhide ? 'password' : 'text'"
        placeholder="Password"
        [(ngModel)]="forgotPasswordValue.password"
        required
        name="password"
      />
      <a
        mat-icon-button
        matSuffix
        (click)="pwdhide = !pwdhide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="pwdhide"
      >
        <mat-icon>{{ pwdhide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </a>
    </mat-form-field>
  </div>

  <div
    *ngIf="current_page == 'verify-forgot-password-otp'"
    class="form-group py-3"
  >
    <mat-form-field class="example-full-width">
      <input
        autocomplete="off"
        required
        matInput
        [type]="confirmpwdhide ? 'password' : 'text'"
        placeholder="Confirm Password"
        [(ngModel)]="forgotPasswordValue.confirm_password"
        required
        name="confirm_password"
      />
      <a
        mat-icon-button
        matSuffix
        (click)="confirmpwdhide = !confirmpwdhide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="confirmpwdhide"
      >
        <mat-icon>{{
          confirmpwdhide ? 'visibility_off' : 'visibility'
        }}</mat-icon>
      </a>
    </mat-form-field>
  </div>

  <div *ngIf="error" class="text-secondary">{{ error }}</div>
  <div class="form-group d-flex flex-wrap flex-center">
    <!-- <button id="kt_login_forgot_submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2">Submit</button> -->

    <button
      type="submit"
      mat-raised-button
      class="btn  sign-btn"
      [disabled]="!forgotpasswordform.valid"
      color="primary"
    >
      Submit
    </button>
    &nbsp;&nbsp;&nbsp;

    <a
      (click)="cancel()"
      mat-raised-button
      class="btn  sign-cancel-btn btn-light-primary btn-bold"
      >Cancel</a
    >

    <!-- <button (click)="cancelForgotPassword()" id="kt_login_forgot_cancel"
            class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2">Cancel</button> -->
  </div>
</form>
